import React, { useRef, useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { Spinner, Button, Row, Col } from "react-bootstrap";
import { ArrowRight, ChartDonut, MapPin, Path, Phone } from "@phosphor-icons/react";
import { API_URL } from "..";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { useMapbox } from "../GoogleMapsContext";

const SearchCompany = () => {
  const { mapboxgl } = useMapbox();
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [showZipAddress, setZipAddress] = useState([]);
  const [affilatesData, setAffilatesData] = useState([]);
  const geocoderRef = useRef(null);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [checkertype, setCheckertype] = useState("");

  useEffect(() => {
    if (checkertype === "address" && inputRef.current && !geocoderRef.current) {
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        types: 'address,poi',
        placeholder: 'Enter Address',
      });

      geocoder.addTo('#address-input-container');
      geocoder.on('result', (e) => {
        const place = e.result;
        setSelectedPlace({
          name: place.text,
          address: place.place_name,
          lat: place.center[1],
          lng: place.center[0]
        });
      });

      geocoderRef.current = geocoder;
    }

    return () => {
      if (geocoderRef.current) {
        geocoderRef.current.onRemove();
      }
    };
  }, [checkertype, mapboxgl]);

  const getLatLngFromZipcode = async (zipcode) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(zipcode)}.json?types=postcode&access_token=${mapboxgl.accessToken}`
      );
      const data = await response.json();

      if (data.features && data.features.length > 0) {
        const filter = data.features.map(feature => feature.place_name);
        setZipAddress(filter);

        const location = data.features[0].center;
        return { lat: location[1], lng: location[0] };
      } else {
        throw new Error("No results found for this zipcode");
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setAffilatesData([]);

    if (checkertype === "zipcode") {
      if (event.target.elements.zipcode.value == "") {
        alert("zip code is required");
        return false;
      }
      getLatLngFromZipcode(event.target.elements.zipcode.value).then(
        async (e) => {
          setLoading(true);
          let headersList = {
            Accept: "*/*",
            "Content-Type": "application/json",
          };

          let bodyContent = JSON.stringify({
            lat: e.lat,
            lng: e.lng,
          });

          let response = await fetch(
            API_URL+"/api/affiliates/nearby",
            {
              method: "POST",
              body: bodyContent,
              headers: headersList,
            }
          );

          let data = await response.json();
          setLoading(false);
          setAffilatesData(data);
        }
      );
    } else if (checkertype == "address") {
      if (!selectedPlace) {
        alert("Please select a valid address");
        return false;
      }
      setLoading(true);
      let headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };

      let bodyContent = JSON.stringify({
        lat: selectedPlace.lat,
        lng: selectedPlace.lng,
      });

      let response = await fetch(
        API_URL+"/api/affiliates/nearby",
        {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        }
      );

      let data = await response.json();
      setLoading(false);
      setAffilatesData(data);
    } 
  };

  const [singleCheckedArray, setSingleCheckedArray] = useState([]);
  const handleAssignClick = (index) => {
    const affiliate = affilatesData[index];
    if (!singleCheckedArray.includes(affiliate.id)) {
      const updatedAffiliatesData = [...affilatesData];
      updatedAffiliatesData[index].status = "marked";
      setAffilatesData(updatedAffiliatesData);
      setSingleCheckedArray([...singleCheckedArray, affiliate]);
    }
  };

  const handleRemoveClick = (index) => {
    const affiliate = affilatesData[index];
    const updatedSingleCheckedArray = singleCheckedArray.filter(
      (item) => item.id !== affiliate.id
    );
    const updatedAffiliatesData = [...affilatesData];
    updatedAffiliatesData[index].status = "active";
    setAffilatesData(updatedAffiliatesData);
    setSingleCheckedArray(updatedSingleCheckedArray);
  };

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Search Company" />
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Search Company </h5>
            </div>
            <div className="card-body">
              <form
                className="row gy-3 needs-validation"
                noValidate=""
                onSubmit={(e) => handleFormSubmit(e)}
              >
                <div className="col-md-12">
                  <div className="d-flex align-items-center flex-wrap gap-24">
                    <div className="bg-warning-100 px-20 py-12 radius-8">
                      <span className="form-check checked-warning d-flex align-items-center gap-2">
                        <input
                          onChange={(e) => {
                            if (e.target.checked == true) {
                              setCheckertype("zipcode");
                            }
                          }}
                          className="form-check-input"
                          type="radio"
                          name="search_type"
                          id="radio400"
                          value={"zipcode"}
                        />
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="radio400"
                        >
                          I have Zipcode
                        </label>
                      </span>
                    </div>
                    <div className="bg-neutral-200 px-20 py-12 radius-8">
                      <span className="form-check checked-dark d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="search_type"
                          id="radio500"
                          value={"address"}
                          onChange={(e) => {
                            if (e.target.checked == true) {
                              setCheckertype("address");
                            }
                          }}
                        />
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="radio500"
                        >
                          I have Address
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-8 mt-20 mb-20">
                  {checkertype === "address" ? (
                    <div id="address-input-container" ref={inputRef}></div>
                  ) : checkertype == "zipcode" ? (
                    <div>
                      <input
                        type="text"
                        name="zipcode"
                        className="form-control"
                        placeholder="Enter Zipcode"
                        required=""
                      />
                    </div>
                  ) : checkertype == "lat_lng" ? (
                    <div className="col-md-6">
                      <input
                        type="text"
                        name="latitude"
                        className="form-control"
                        placeholder="Enter Lat"
                        required
                      />
                      <br></br>
                      <input
                        type="text"
                        name="longitude"
                        className="form-control"
                        placeholder="Enter Lng"
                        required
                      />
                    </div>
                  ) : null}
                  <div className="valid-feedback">Looks good!</div>
                </div>

                <div className="col-12">
                  <button className="btn btn-primary-600" type="submit">
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="mb-40 mt-40">
          <div className="row mb-8">
            <div className="col-md-6">
              <h6 className="mb-24">Search Results </h6>
            </div>
            <div className="col-md-6" style={{textAlign:'end'}}>
              {singleCheckedArray.length !== 0 && 
                <Link
                  to={'/assign-job'}
                  state={{ assigned_To: singleCheckedArray }}
                >
                  Add Job Information <ArrowRight/>
                </Link>
              }
            </div>
          </div>
          <div className="row gy-4">
            {loading ? <Spinner size="lg" /> : null}
            {affilatesData.map((e, index) => {
              return (
                <div key={index} className="col-xxl-3 col-sm-6">
                  <div className="card radius-12">
                    <div className="card-body p-24">
                      <div className="row">
                        <div className="col-md-12">
                          <p style={{fontSize: 18, fontWeight: 'bold'}} className="mb-8">{e?.business_name}</p>
                        </div>
                        <div className="col-md-12">
                          <Row>
                            <Col md="2"> 
                              <MapPin size={22} /> 
                            </Col>
                            <Col md="10">
                              <span>{e?.address}</span>
                            </Col>
                          </Row>
                        </div>
                        <div className="col-md-12">
                          <Row>
                            <Col md="2"> 
                              <Phone size={22} />
                            </Col>
                            <Col md="10">
                              <span>{e?.phone}</span>
                            </Col>
                          </Row>
                        </div>
                        <div className="col-md-12">
                          <Row>
                            <Col md="2"> 
                              <ChartDonut size={22} />
                            </Col>
                            <Col md="10">
                              <span>{e?.status}</span>
                            </Col>
                          </Row>
                        </div>
                        <div className="col-md-12">
                          <Row>
                            <Col md="2"> 
                              <Path size={22} /> 
                            </Col>
                            <Col md="10">
                              <span>{Math.round(parseFloat(e?.distance)) + "KM"}</span>
                            </Col>
                          </Row>
                        </div>
                        <div className="col-md-12">
                          <Row style={{marginTop: 10}}>
                            <Col md="6">
                              {e.status === 'marked' ? (
                                <Button 
                                  style={{width: '100%'}}
                                  variant="outline-danger" 
                                  onClick={() => handleRemoveClick(index)}
                                  className="mt-2"
                                >
                                  Remove
                                </Button>
                              ) : (
                                <Button 
                                  variant="outline-success" 
                                  onClick={() => handleAssignClick(index)}
                                  className="mt-2"
                                  style={{width: '100%'}}
                                >
                                  Assign
                                </Button>
                              )}
                            </Col>
                            <Col md="6" style={{marginTop:3}}>
                              <Button style={{width: '100%'}} variant="outline-primary">
                                <Link to={`/view-business-profile/${e.id}`}>
                                  View 
                                </Link>
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default SearchCompany;